module.exports = __webpack_public_path__ + "img/kuzzle-iot.db84458c.png";